/**
 * ss-micro-strip.js — drag + wheel support
 */
(function () {
  'use strict';
  function init(rail) {
    if (!rail || rail.dataset.ready) return;
    rail.dataset.ready = '1';
    var startX = 0, scrollLeft = 0, down = false;

    rail.addEventListener('pointerdown', function (e) {
      down = true;
      rail.classList.add('is-paused');
      startX = e.clientX;
      scrollLeft = rail.scrollLeft || 0;
      rail.setPointerCapture(e.pointerId);
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) rail.scrollLeft = scrollLeft - dx;
    });
    function up() {
      down = false;
      setTimeout(function () { rail.classList.remove('is-paused'); }, 800);
    }
    rail.addEventListener('pointerup', up);
    rail.addEventListener('pointercancel', up);

    rail.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        rail.classList.add('is-paused');
        rail.scrollLeft += e.deltaY;
        e.preventDefault();
        clearTimeout(rail._t);
        rail._t = setTimeout(function () { rail.classList.remove('is-paused'); }, 900);
      }
    }, { passive: false });
  }
  function boot() {
    document.querySelectorAll('[data-ss-micro-rail]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
